export enum OrderStatus {
New,
Completed,
Submitted,
}
